// extracted by mini-css-extract-plugin
module.exports = {"markdown":"Markdown_markdown_22kWg"};